import {
  AUTHENTICATING_LINKEDIN_ACCOUNT,
  AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED,
  AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED,
  DEACTIVATE_LINKEDIN_ACCOUNT,
  DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED,
  DEACTIVATING_LINKEDIN_ACCOUNT_FAILED,
  FETCH_LINKEDIN_INTEGRATION,
  FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED,
  FETCHING_LINKEDIN_INTEGRATION_FAILED,
  INVALIDATE_LINKEDIN_INTEGRATION,
  SHARE_LINKEDIN_POST_REQUEST,
  SHARING_LINKEDIN_POST_SUCCEEDED,
  SHARING_LINKEDIN_POST_FAILED,
  INVALIDATE_LINKEDIN_POST
} from '../actionTypes';
import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import buildUrl from 'build-url-ts';
import { takeEvery, takeLatest, call, put } from "redux-saga/effects";
import { IAuthenticateLinkedInErrorResponse, IAuthenticateLinkedInRequest, IDeactivateLinkedInErrorResponse, IFetchIntegrationErrorResponse, IIntegration } from 'src/types/integrations/linkedIn';
import { ILinkedInShareRequest } from 'src/types/shareTemplate';

export const invalidateLinkedInIntegration = createAction<void>(INVALIDATE_LINKEDIN_INTEGRATION);

export const authenticateLinkedIn = createAction<IAuthenticateLinkedInRequest>(AUTHENTICATING_LINKEDIN_ACCOUNT);
const authenticatingLinkedInSucceeded = createAction<IIntegration>(AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED);
const authenticatingLinkedInFailed = createAction<IAuthenticateLinkedInErrorResponse>(AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED);

const apiUrl = process.env.REACT_APP_API_URL;
const API_BASE_URL = `${apiUrl}/api/2.0`;
const LINKEDIN_URL = `${API_BASE_URL}/integrations/linkedin`

const authenticateLinkedInSaga = function* (action: ReturnType<typeof authenticateLinkedIn>): any {
  const code = action.payload.code;
  const url = buildUrl(LINKEDIN_URL,{
    queryParams:{
      code: code
    }
  })

  const authenticateLinkedInAPI = () => {
    return axios({
      method: "POST",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(authenticateLinkedInAPI);
    yield put(authenticatingLinkedInSucceeded(response));
  } catch (error) {
    yield put(authenticatingLinkedInFailed({ error }));
  }
}

export const deactivateLinkedInAccount = createAction<void>(DEACTIVATE_LINKEDIN_ACCOUNT);
const deactivatingLinkedInAccountSucceeded = createAction<any>(DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED);
const deactivatingLinkedInAccountFailed = createAction<IDeactivateLinkedInErrorResponse>(DEACTIVATING_LINKEDIN_ACCOUNT_FAILED);

const deactivateLinkedInAccountSaga = function* (): any {
  const deactivateLinkedInAccountAPI = () => {
    return axios({
      method: "DELETE",
      url: LINKEDIN_URL
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deactivateLinkedInAccountAPI);
    yield put(deactivatingLinkedInAccountSucceeded(response));
  } catch (error) {
    yield put(deactivatingLinkedInAccountFailed(error as IDeactivateLinkedInErrorResponse));
  }
}

export const fetchLinkedInIntegration = createAction<void>(FETCH_LINKEDIN_INTEGRATION);
const fetchingLinkedInIntegrationSucceeded = createAction<IIntegration>(FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED);
const fetchingLinkedInIntegrationFailed = createAction<IFetchIntegrationErrorResponse>(FETCHING_LINKEDIN_INTEGRATION_FAILED);

const fetchLinkedInIntegrationSaga = function* (): any {
  const fetchLinkedInIntegrationAPI = () => {
    return axios({
      method: "GET",
      url: LINKEDIN_URL
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLinkedInIntegrationAPI);
    yield put(fetchingLinkedInIntegrationSucceeded(response));
  } catch (error) {
    yield put(fetchingLinkedInIntegrationFailed(error as IFetchIntegrationErrorResponse));
  }
}

export const invalidateLinkedInPost = createAction(INVALIDATE_LINKEDIN_POST);

export const shareLinkedInPostRequest = createAction<ILinkedInShareRequest>(SHARE_LINKEDIN_POST_REQUEST);
const sharingLinkedInPostSucceeded = createAction<any>(SHARING_LINKEDIN_POST_SUCCEEDED);
const sharingLinkedInPostFailed = createAction<any>(SHARING_LINKEDIN_POST_FAILED);

const shareLinkedInPostSaga = function* (action : ReturnType<typeof shareLinkedInPostRequest>): any {
  const id = action.payload.entityId;
  const entityType = action.payload.entityType;
  const requestBody = action.payload.requestBody;
  
  const url = buildUrl(`${LINKEDIN_URL}/post/${id}`,{
    queryParams:{
      type: "asset"
    }
  })


  const shareLinkedInPostAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: requestBody
    }).then((response) => response.data);
  };

  try {
    const response = yield call(shareLinkedInPostAPI);
    yield put(sharingLinkedInPostSucceeded(response));
  } catch (error) {
    yield put(sharingLinkedInPostFailed(error));
  }
}

export default function* linkedInIntegrationSaga() {
  yield takeEvery(AUTHENTICATING_LINKEDIN_ACCOUNT, authenticateLinkedInSaga);
  yield takeEvery(FETCH_LINKEDIN_INTEGRATION, fetchLinkedInIntegrationSaga);
  yield takeEvery(DEACTIVATE_LINKEDIN_ACCOUNT, deactivateLinkedInAccountSaga);
  yield takeEvery(SHARE_LINKEDIN_POST_REQUEST, shareLinkedInPostSaga);
}